import React, { useEffect, useRef } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import "../Assets/css/PaymentSuccess.css"; // Custom CSS
import axiosUserInstance from "../axiosUserInstance";

const PaymentSuccess = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const plan = params.get("plan");
  const reference = params.get("reference");
  const status = params.get("status");
  const gateway = params.get("gateway") || "hitpay";

  const verificationAttempted = useRef(false);

  useEffect(() => {
    // Ensure API is only called once
    if (verificationAttempted.current) return;

    if (status === "completed" && reference) {
      verificationAttempted.current = true;
      
      axiosUserInstance
        .post("/payment/verify", { reference, plan, gateway })
        .then((res) => {
          // console.log("Payment verified:", res.data);
        })
        .catch((err) => {
          console.error(
            "Verification failed:",
            err.response?.data || err.message
          );
        });
    }
  }, []);

  return (
    <Container className="payment-success-container">
      <Row className="justify-content-center w-100">
        <Col md={6}>
          <Card
            className={`payment-card ${
              status === "completed" ? "success" : "failure"
            }`}
          >
            <div className="icon-wrapper">
              {status === "completed" ? (
                <div className="check-icon text-center">&#10004;</div>
              ) : (
                <div className="cross-icon text-center">&#10006;</div>
              )}
            </div>
            <Card.Body className="text-center">
              {status === "completed" ? (
                <>
                  <Card.Title className="card-title">
                    Payment Successful!
                  </Card.Title>
                  <Card.Text className="card-text">
                    Thank you for subscribing to <strong>{plan}</strong> plan.
                  </Card.Text>
                  <Card.Text className="card-ref">
                    Reference ID: <code>{reference}</code>
                  </Card.Text>
                  <Link to="/user/dashboard">
                    <Button variant="success" className="action-btn">
                      Go to Dashboard
                    </Button>
                  </Link>
                </>
              ) : (
                <>
                  <Card.Title className="card-title">Payment Failed</Card.Title>
                  <Card.Text className="card-text">
                    Something went wrong. Please try again.
                  </Card.Text>
                  <Link to="/user/dashboard?type=plan">
                    <Button variant="danger" className="action-btn">
                      Retry Payment
                    </Button>
                  </Link>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentSuccess;
